<script>
import { VAlert, VCardText, VCardTitle, VCardSubtitle } from 'vuetify/lib'

export default {
  name: "TcnFormThypography",
  components: {},
  props: {
    value: {default: null},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
  },
  data() {
    return {
      localText: null,
      localClass: null,
      component: null
    }
  },
  computed: {},
  watch: {},
  methods: {},
  render(createElement) {

    const child = createElement("div", {
      domProps: {innerHTML: 'x-content' in this.schema ? this.schema['x-content'] : "Brak dyrektywy x-content w schema"},
      class: 'x-content-class' in this.schema ? this.schema['x-content-class'] : ""
    });

    const element = () => {
      switch (this.schema['x-tag']) {
        case "v-alert": {
          return VAlert
        }
        case "v-card-title": {
          return VCardTitle
        }
        case "v-card-subtitle": {
          return VCardSubtitle
        }
        case "v-card-text": {
          return VCardText
        }
        default:
          return 'div'
      }
    }

    return createElement(element(), {
      class: 'x-class' in this.schema ? this.schema['x-class'] : null,
      props: 'x-props' in this.schema ? this.schema['x-props'] : null,
    }, [child])
  }
}
</script>

<style scoped lang="css">

</style>
